export default __webpack_public_path__ + "static/media/landingPage_3.678f69ce.jpg";